/**
 * The user directory — names for the uuids every other endpoint returns.
 *
 * Its own feature slice rather than part of `auth`, because it is read by
 * records (version history), submissions (the approval trail) and
 * handovers (the target picker), and none of those is an auth concern.
 */

import { client } from "@/lib/api/client";
import type { components } from "@/lib/api/schema";

export type DirectoryUser = components["schemas"]["DirectoryUserOut"];

export interface DirectoryParams {
  /** Narrows to holders of one role — what a handover target picker
   *  wants, so it offers only people the server would accept. */
  role?: string | undefined;
  masterTypeId?: string | undefined;
}

export function listDirectory(params: DirectoryParams = {}): Promise<DirectoryUser[]> {
  return client.request<DirectoryUser[]>("/api/v1/directory/users", {
    query: { role: params.role, master_type_id: params.masterTypeId },
  });
}
